@if (storyActivities.length > 0) {
  <lp-story-activity [storyActivity]="storyActivities()[selectedStoryIndex()]" style="display: block; width: 100vw; height: 100vh" />
}

<select (change)="changeSelectedStory($event)" style="position: absolute; top: 0; inset-inline: 0">
  @for (storyActivity of storyActivities(); track $index) {
    <option value="{{ storyActivity.uid }}">{{ storyActivity.name }}</option>
  }
</select>
